<template>
  <div class="import-order-container">
    <el-upload
        v-if="userAuth.can_create_adv_order"
        action="/api/orders/import"
        :on-change="handleChange"
        :on-success="importSuccess"
        :headers="headerToken"
        name="file"
        :show-file-list="false"
        :file-list="file"
        :before-upload="beforeUpload"
    >
      <el-button class="d-flex-row funcbars-button" style="margin-right: 10px" size="mini"><i
          class="el-icon-upload"></i>导入订单
      </el-button>
    </el-upload>

    <!--    订单导入-->
    <el-dialog title="导入预览" :visible.sync="dialogImportOrder" width="80%" :modal-append-to-body="false"
               :append-to-body="false">
      <div v-if="!importOrderError" style="max-height: 800px">
        <el-alert type="warning" v-if="importExceptions.warn" class="custom-alert" :closable="false">
          <template slot='title'>
            <div style="font-weight: bold;text-align: left;">Excel 警告</div>
            <div style="text-align: left;"> {{ importExceptions.warn }}</div>
          </template>
        </el-alert>
        <br/>
        <div class="data-table">
          <el-table :data="importOrderData" ref="importOrderTable" style="width: 100%" id="import-order-table"
                    height="400">
            <el-table-column type="selection" width="55"/>
            <el-table-column prop="company" label="乙方"/>
            <el-table-column prop="executor" label="执行"/>
            <el-table-column prop="sale" label="销售"/>
            <el-table-column prop="organization_name" label="销售小组"/>
            <el-table-column prop="customer_name" label="公司名称" width="150" show-overflow-tooltip/>
            <el-table-column prop="customer_nature" label="客户性质" show-overflow-tooltip/>
            <el-table-column prop="order_source" label="订单来源" show-overflow-tooltip/>
            <el-table-column prop="brand" label="品牌" show-overflow-tooltip/>
            <el-table-column prop="passenger_order_interval" label="客单" show-overflow-tooltip/>
            <el-table-column prop="product_category" label="品类" show-overflow-tooltip/>
            <el-table-column prop="form_of_cooperation" label="合作形式" show-overflow-tooltip/>
            <el-table-column prop="product" label="产品" show-overflow-tooltip/>
            <el-table-column prop="trade" label="行业" show-overflow-tooltip/>
            <el-table-column prop="release_timestamp" label="发布时间" min-width="95" show-overflow-tooltip/>
            <el-table-column prop="created_timestamp" label="下单日期" min-width="95" show-overflow-tooltip/>
            <el-table-column prop="artist_name" label="红人" show-overflow-tooltip/>
            <el-table-column prop="platforms" label="平台" show-overflow-tooltip/>
            <el-table-column prop="content_forms" label="形式" show-overflow-tooltip/>
            <el-table-column prop="strategy" label="策略" show-overflow-tooltip/>
            <el-table-column prop="medium" label="媒介" show-overflow-tooltip/>
            <el-table-column prop="planner" label="策划" show-overflow-tooltip/>
            <el-table-column prop="payment_account" label="含税收入" show-overflow-tooltip/>
            <el-table-column prop="place_order_money" label="下单金额" show-overflow-tooltip/>
            <el-table-column prop="exec_price" label="广告执行价" min-width="100"/>
            <el-table-column prop="rebates_rate" label="返点金额/返点比例" min-width="120">
              <template slot-scope="scope">
                {{
                  scope.row.rebates_handle === 'rebates_rate' ? scope.row.rebates_rate +
                      '%' : scope.row.rebates_amount
                }}
              </template>
            </el-table-column>
            <el-table-column prop="platform_fee_po" label="代下单平台费" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="weal_price" label="粉丝福利" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="authorized_price" label="授权价" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="micro_task_price" label="微任务价" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="other_fee" label="其他费" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="pay_method" label="支付方式" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="is_trailer" label="是否挂车" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.is_trailer ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="commission_trailer" label="挂车佣金" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.commission_trailer ? scope.row.commission_trailer + '%' : null }}
              </template>
            </el-table-column>
            <el-table-column prop="cart_charges" label="购物车费用" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="is_lb" label="是否直播" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.is_lb ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column prop="commission_rate" label="直播佣金" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.commission_rate ? scope.row.commission_rate + '%' : null }}
              </template>
            </el-table-column>
            <el-table-column prop="cart_commission" label="坑位费" min-width="100" show-overflow-tooltip/>
            <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip/>
          </el-table>
        </div>

        <div style="margin-top: 5px;text-align: center;">
          <el-button @click="dialogImportOrder = false" size="mini">取{{ '\u3000\u3000' }}消</el-button>

          <el-button type="primary" @click="submitImport" size="mini"
                     :loading="submitImportLoading" :disabled="submitImportLoading">确认导入
          </el-button>
        </div>
      </div>
      <div v-else>
        <el-alert type="error" class="custom-alert" :closable="false">
          <template slot='title' style="width: 100%">
            <div style="font-weight: bold;margin-bottom:10px ">Excel
              共{{ importExceptions.errors.length }}条数据错误，请仔细核对excel中数据是否正确
            </div>
            <div v-for="(item, index) in importExceptions.errors" :key="index"
                 style="text-align: left;width: 65%;margin: 0 auto;margin-bottom: 5px;">
              【第&nbsp;{{ item.row_no }}&nbsp;行】
              <ol start="1">
                <li v-for="(value,k) in item.data" :key="k" style="padding-left: 5px;">
                  <span v-if="value.column_no">&nbsp;{{ value.column_no }}&nbsp; {{ value.data }}</span>
                  <span v-else>&nbsp;{{ value }}</span>
                </li>
              </ol>

            </div>
          </template>
        </el-alert>
        <br/>
        <el-alert type="warning" v-if="importExceptions.warn" class="custom-alert" :closable="false">
          <template slot='title'>
            <div style="font-weight: bold;">Excel 警告</div>
            <div style="text-align: left;width: 65%;margin: 0 auto;"> {{ importExceptions.warn }}</div>
          </template>
        </el-alert>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {postOrdersBatchCreate} from "@/api/adOrder";

export default {
  name: "AdImportOpt",
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    headerToken() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    },
  },
  data() {
    return {
      file: [],
      uploadLoading: false,
      submitImportLoading: false,
      dialogImportOrder: false,
      importExceptions: {
        errors: [],
        warn: '',
      },
      importOrderError: false,
      importFileName: '',
      importOrderData: [],

      formData: {data: [], file_name: ''},
    }
  },
  methods: {
    handleChange(file) {
      this.file = [file];
    },

    importSuccess(response) {
      if (response.success) {
        setTimeout(() => {
          this.uploadLoading = false;
          this.dialogImportOrder = true
        }, 1000);
        const res = response.model
        if (res.warn) {
          this.showToast({
            h: this,
            icon: 'el-icon-warning',
            text: res.warn
          })
        }
        this.importOrderError = !res.flag
        if (res.flag) {
          this.importOrderData = res.data
          this.importFileName = res.file_name
          this.importExceptions.warn = res.warn
        } else {
          this.importExceptions.errors = res.errors
          this.importExceptions.warn = res.warn
        }
      } else {
        this.uploadLoading = false;
        this.$message.warning(response.message);
      }
    },
    beforeUpload(file) {
      this.uploadLoading = true;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error("导入文件大小不能超过 5MB!");
        this.uploadLoading = false
      }
      return isLt2M;
    },
    submitImport() {
      this.submitImportLoading = true
      const data = this.$refs['importOrderTable'].selection
      if (data.length < 1) {
        this.showToast({
          h: this,
          icon: 'el-icon-warning',
          text: '请选择需要导入的条目'
        })
        setTimeout(() => {
          this.submitImportLoading = false;
        }, 500);
        return;
      }
      this.formData.data = data
      this.formData.file_name = this.importFileName

      postOrdersBatchCreate(this.formData).then((res) => {
        if (res.success) {
          this.dialogImportOrder = false
          this.submitImportLoading = false;
          this.$message.success('操作成功')
          this.$emit('imported');
        }
      })
      setTimeout(() => {
        this.submitImportLoading = false;
      }, 3000);
    }
  }
}
</script>

<style lang="scss" scoped>
.funcbars-button {
  padding: 3px 8px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
  flex: 1;
}

.funcbars-button i {
  width: 14px;
  height: 14px;
  font-weight: bold;
  line-height: 1.4;
  margin-right: 5px;
}

.funcbars-button i svg {
  width: 100%;
  height: 100%;
  fill: rgb(254, 45, 84);
}

.import-btn {
  margin-right: 20px;
  background-color: #FF5722;
  color: #ffffff !important;
  border-color: #FF5722;
}

.import-btn:active {
  background-color: #f98846;
}

.import-btn > div > div {
  color: #ffffff !important;
}

</style>
<style lang="scss">
.import-order-container {
  .custom-alert {
    .el-alert__content {
      width: 100%;
    }
  }
}
</style>
